// Clerk resources are passed in, so this module stays free of Clerk imports and runs against fakes in tests.
type ClerkResult = { error: unknown }
type SingleSignOnRedirect = { strategy: "enterprise_sso"; redirectUrl: string; redirectCallbackUrl: string }

export type SignInResource = {
  create(params: { identifier: string }): Promise<ClerkResult>
  readonly supportedFirstFactors: readonly { strategy?: string }[]
  sso(params: SingleSignOnRedirect): Promise<ClerkResult>
}

export type SignUpResource = {
  create(params: { strategy: "ticket"; ticket: string }): Promise<ClerkResult>
  readonly missingFields: readonly string[]
  sso(params: SingleSignOnRedirect): Promise<ClerkResult>
}

export const SINGLE_SIGN_ON_CALLBACK_PATH = "/login/sso-callback"

/** Clerk offers only enterprise_sso for an email on a domain with single sign-on turned on. */
export async function emailUsesSingleSignOn(signIn: SignInResource, emailAddress: string): Promise<boolean> {
  if (!emailAddress) return false
  const created = await signIn.create({ identifier: emailAddress })
  if (created.error) return false
  return signIn.supportedFirstFactors.some((factor) => factor.strategy === "enterprise_sso")
}

/** An invitation to an email on such a domain can only finish through enterprise_sso; the ticket stays usable. */
export async function invitationUsesSingleSignOn(signUp: SignUpResource, ticket: string): Promise<boolean> {
  const created = await signUp.create({ strategy: "ticket", ticket })
  if (created.error) return false
  return signUp.missingFields.includes("enterprise_sso")
}

export function continueWithSingleSignOn(resource: SignInResource | SignUpResource, redirectUrl: string) {
  return resource.sso({ strategy: "enterprise_sso", redirectUrl, redirectCallbackUrl: SINGLE_SIGN_ON_CALLBACK_PATH })
}
